if (!customElements.get('product-price')) {
  customElements.define(
    'product-price',
    class ProductPrice extends HTMLElement {
      constructor() {
        super();

        this.priceContainer = this.querySelector('.price__container');
      }
     

      /**
       * Applies price adjustments from the base price
       * @param {*} adjustment: { 
       *  value_type: "percentage" | "fixed_amount" | "price" | "reset", 
       *  value: number 
       * }
       * @returns 
       */
      applyAdjustment(adjustment) {
        const regularUnitPrices = this.querySelectorAll('.unit-price [data-unit-price]');
        const regularPrice = this.priceContainer.querySelector('.price__regular .price-item--regular');
        const regularPriceValue = parseInt(regularPrice.dataset.price);
        const pricePerServing = this.querySelector('.price__servings_money');


        if (adjustment?.value_type !== "percentage") {
          // we do not support any other price adjustment than percentage for the moment
            // reset price to original
          regularUnitPrices.forEach((regularUnitPrice) => {
            const regularUnitPriceValue = parseInt(regularUnitPrice.dataset.unitPrice);
            regularUnitPrice.innerHTML = formatMoney(regularUnitPriceValue);
          });

          this.priceContainer.classList.remove('price--on-sale');

          if (pricePerServing) {
            pricePerServing.innerHTML = formatMoney(regularPriceValue / pricePerServing.dataset.numServings);
          }

          return
        }

        /** apply main price adjustment */

        // 2. update sale price in sale price container
        const salePrice = this.priceContainer.querySelector('.price__sale .price-item--sale');
        const salePriceValue = regularPriceValue * (1 - adjustment.value / 100);
        salePrice.innerHTML = formatMoney(salePriceValue);

        // 3. update regular price in sale price container
        const strikeThroughRegularPrice = this.priceContainer.querySelector('.price__sale .price-item--regular');
        strikeThroughRegularPrice.innerHTML = formatMoney(regularPriceValue);

        // 4. add .price--on-sale class to price container to switch from regular to sale price
        this.priceContainer.classList.add('price--on-sale');

        /** apply unit price adjustment */
        regularUnitPrices.forEach((regularUnitPrice) => {
          const regularUnitPriceValue = parseInt(regularUnitPrice.dataset.unitPrice);
          regularUnitPrice.innerHTML = formatMoney(regularUnitPriceValue * (1 - adjustment.value / 100));
        });

        /** apply price per serving adjustment */
        if (pricePerServing) {
          pricePerServing.innerHTML = formatMoney(salePriceValue / pricePerServing.dataset.numServings);
        }
      }

    }
  );
}
